import { useLang } from "@/context/LanguageContext";

// Google's official "Share to Classroom" URL: teachers pick their class and post it as an assignment (no API key needed).
export const classroomShareUrl = (lesson) => {
  const url = `${window.location.origin}/virtual-classroom?lesson=${lesson.slug}`;
  const body = `Watch this RoboSpark lesson with Zoya Ma'am (AI teacher). Answer her quiz in class and use "Raise hand" to ask your doubts.`;
  return `https://classroom.google.com/share?url=${encodeURIComponent(url)}&title=${encodeURIComponent(`RoboSpark: ${lesson.title}`)}&body=${encodeURIComponent(body)}&itemtype=assignment`;
};

const GcIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5" aria-hidden><rect x="2" y="4" width="20" height="16" rx="2" fill="#1e8e3e" /><rect x="4" y="6" width="16" height="12" rx="1" fill="#34a853" /><circle cx="12" cy="10.5" r="2" fill="#fff" /><path d="M8.5 16c.4-1.8 1.8-2.8 3.5-2.8s3.1 1 3.5 2.8" fill="#fff" /><rect x="14" y="17.5" width="5" height="1.5" fill="#fff" /></svg>
);

export const ShareToClassroom = ({ lesson, testid = "share-google-classroom-btn", compact }) => {
  const { L } = useLang();
  return (
    <a href={classroomShareUrl(lesson)} target="_blank" rel="noopener noreferrer" data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full bg-white text-[#0A192F] font-bold hover:bg-slate-100 transition-[background-color,transform] active:scale-95 ${compact ? "px-3 h-9 text-xs" : "px-5 h-11 text-sm"}`}>
      <GcIcon />{L("Share to Google Classroom", "Google Classroom पर शेयर करें")}
    </a>
  );
};
